import {Injectable}                                      from '@angular/core';
import {AgriportConstantsEnum, BaseFertLicenseAmountAbs} from '../../../ap-interface/enums/ap-agriport-constants.enum';
import {AgriportConstantsService}                        from '../../common/agriport-constants.service';

@Injectable({providedIn: 'root'})
export class LicenseAreaCheckService {
  constructor(private agriportConstantsService: AgriportConstantsService) {
  }

  public isBaseFertilizationAreaTooSmall(licencedAmount: number | undefined, fieldsAreaHaSum: number | undefined): boolean {
    if (!Number.isFinite(licencedAmount) || !Number.isFinite(fieldsAreaHaSum)) {
      return false;
    }
    let quantityForConditionActivation = 0;
    const licenseComparisonType = this.agriportConstantsService.GetConstant(AgriportConstantsEnum.BaseFertLicenseAmountAbs);
    const licenseComparisonAmount = +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.BaseFertLicenseAmountDiff);
    if (!isFinite(licenseComparisonAmount) || licenseComparisonAmount <= 0) {
      return false;
    }
    switch (licenseComparisonType) {
      case BaseFertLicenseAmountAbs.Hectare:
        quantityForConditionActivation = licenseComparisonAmount;
        break;
      case BaseFertLicenseAmountAbs.Percent:
        quantityForConditionActivation = fieldsAreaHaSum * licenseComparisonAmount / 100;
        break;
    }
    switch (true) {
      case fieldsAreaHaSum >= licencedAmount + quantityForConditionActivation:
        return true;
      default:
        return false;
    }
  }
}
